import { Menu } from '@mantine/core';
import PageSizeOptions from '../constants/pageSizeOptions';

const usePageSizeDropdown = (size, setPageSize) =>
  PageSizeOptions.map((pageSizeOption, i) =>
    parseInt(size) !== pageSizeOption ? (
      <Menu.Item key={i} onClick={() => setPageSize(pageSizeOption)}>
        {pageSizeOption}
      </Menu.Item>
    ) : null
  );

export default usePageSizeDropdown;
